export default "/dist/7edeedf7c96429c70573f660f4448ddc.png";